module.exports = __webpack_public_path__ + "static/media/designPatent_30-0992961.850cd4a2.png";